<template>
  <div v-html="data">
  </div>
</template>
<script>
import data from './data.js'
export default {
  data () {
    return {
      ...data
    }
  }
}
</script>
<style scoped lang='sass'>
</style>
